var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!['OrderProofReview', 'OrderProofView','pendingPayment'].includes(_vm.$route.name))?_c('RwvHeader'):(['OrderProofReview', 'OrderProofView'].includes(_vm.$route.name))?_c('OrderProofReviewHeader'):_vm._e(),_c('router-view',{key:_vm.$route.path}),(
            ![
                'DesignStudioNew',
                'DesignStudio',
                'DesignStudioV2',
                'DesignStudioV3',
                'DesignStudioBuildV3',
                'pendingPayment'

            ].includes(_vm.$route.name)
        )?_c('RwvFooter',{staticClass:"no-print"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }